module.exports = __webpack_public_path__ + "img/6.7ed73cc0.jpg";